import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=78995f16"
import script from "./BannerForm.vue?vue&type=script&lang=js"
export * from "./BannerForm.vue?vue&type=script&lang=js"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=78995f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTimer: require('/usr/src/app/components/ui/Timer.vue').default,InputValidationInput: require('/usr/src/app/components/input/ValidationInput.vue').default,InputPhoneInput: require('/usr/src/app/components/input/PhoneInput.vue').default,Form: require('/usr/src/app/components/form/index.vue').default})
